import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    cajaRegistroId: 0,

    cajaMovimientos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
};

const mutations = {
    updateField,

    'INICIALIZAR_CAJA_MOVIMIENTOS' (state, cajaRegistroId) {
        state.cajaRegistroId = cajaRegistroId;
        state.cajaMovimientos = [];
    },
    'SET_CAJA_MOVIMIENTOS' (state, cajaMovimientos) {
        state.cajaMovimientos = cajaMovimientos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    getCajaMovimientos ( { commit }, cajaRegistroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CAJA_MOVIMIENTOS', cajaRegistroId);

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
  
            apiAxios.get('cajas/' + cajaRegistroId + '/movimientos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_CAJA_MOVIMIENTOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    abrirCaja ( {}, cajaId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('cajas/abrir/' + cajaId)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}